import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Skeleton,
    TableCell, Link, Table, TableHead, TableRow, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {
    useLazyGetAvailableSemestersForGroupQuery,
    useLazyGetGroupInfoQuery,
    useLazyGetGroupsByPatternQuery, useGetStudentsInGroupQuery
} from "../store/group/groupApi";
import copyObject from "../utils/copyObject";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {useGetStudentDetailsBySemesterQuery, useStudentsDetailsBySemesterMutation} from "../store/student/studentApi";
import {Download} from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";

export default function GroupCardPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [getGroups] = useLazyGetGroupsByPatternQuery();
    const [groups, setGroups] = useState([]);
    const [groupsListIsLoading, setGroupsListIsLoading] = useState(false);
    const [groupPattern, setGroupPattern] = useState('');
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(null);
    const [semesters, setSemesters] = useState([]);
    const [getSemesters] = useLazyGetAvailableSemestersForGroupQuery();
    const [semestersListIsLoading, setSemestersListIsLoading] = useState(false);
    const [getGroupInfo] = useLazyGetGroupInfoQuery();
    const [groupData, setGroupData] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const {data: studentsInGroupData} = useGetStudentsInGroupQuery({groupId: selectedGroupId, includeExpelled: true});
    const [studentsInGroup, setStudentsInGroup] = useState([]);
    const [studentDetailsCache, setStudentDetailsCache] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [studentsDetailsRequest] = useStudentsDetailsBySemesterMutation();
    const [studentsDetails, setStudentsDetails] = useState([]);
    const [studentsDataIsLoading, setStudentsDataIsLoading] = useState(false);
    const [reportIsLoading, setReportIsLoading] = useState(false);

    useEffect(() => {
        if (studentsInGroupData) {
            setStudentsInGroup(copyObject(studentsInGroupData.data));
        }
    }, [studentsInGroupData, selectedSemester]);

    async function loadStudentsData(studentIds) {
        if (!studentIds || studentIds.length === 0) {
            return;
        }
        
        setStudentsDataIsLoading(true);
        await studentsDetailsRequest({
            data: {
                studentIds,
                semesterId: parseInt(selectedSemester.key, 10)
            }
        }).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setStudentsDetails(copyObject(fulfilled.details))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
            
            setStudentsDataIsLoading(false);
        }).catch(() => {
            alert('Ошибка');
            setStudentsDataIsLoading(false);
        });
    }

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };

    async function findGroup() {
        setGroupsListIsLoading(true);
        await getGroups({data: {pattern: groupPattern}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setGroups(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setGroupsListIsLoading(false);
        }).catch(() => {
            setGroupsListIsLoading(false);
            alert('Ошибка');
        });
    }

    async function getAvailableSemesters(groupId) {
        setSemestersListIsLoading(true);
        await getSemesters({data: {groupId}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setSemesters(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setSemestersListIsLoading(false);
        }).catch(() => {
            setSemestersListIsLoading(false);
        });
    }

    function loadData(semesterId) {
        setStudentsDetails([]);
        // setSelectedGroupId(selectedGroup.groupId);
        getGroupGeneralInfo(semesterId);
        loadStudentsData(studentsInGroupData?.data?.map((item) => parseInt(item.key, 10)));
    }

    async function getGroupGeneralInfo(semesterId) {
        setIsLoading(true);
        await getGroupInfo({
            data: {
                groupId: selectedGroup.groupId,
                semesterId: parseInt(semesterId, 10)
            }
        }).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setGroupData(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    function getSessionDetailElements(details) {
        return <>
            <TableCell>{details.controlType}</TableCell>
            <TableCell>{details.employees.join(', ')}</TableCell>
            <TableCell>
                <Link href={`/statementresults/${details.statementId}`}
                      target={"_blank"}>Ведомость №{details.statementNumber}</Link>
                {details.closingDate !== null
                    ? <small><br/> Закрыта {toDateString(details.closingDate)}</small>
                    : <small><br/> Открыта</small>}
            </TableCell>
            <TableCell>
                {details.grade}
            </TableCell>
        </>
    }
    
    function printReport() {
        downloadReport();
    }

    function downloadReport() {
        setReportIsLoading(true);
        fetch(`/Reports/GroupDetailsReport?groupId=${selectedGroupId}&fileType=xlsx`,
            {
                method: "GET",
                headers: {
                    "semesterid": localStorage.getItem("selectedSemesterId"),
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            }).then(response => {
            setReportIsLoading(false);
            return response.blob();
        }).then(response => {
            if (response.size < 1024*0) { // отсекаем все, что ниже 10кб
                alert('Не удалось загрузить файл')
                return;
            }

            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Отчет по группе ${selectedGroup.groupName}.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }).catch((e) => {
            alert('Ошибка')
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Карточка группы`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Карточка группы
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography variant={'subtitle1'}>Фильтры</Typography>
                                <Stack direction={'row'} spacing={1}>
                                    <TextField size={'small'}
                                               fullWidth
                                               id={'groupfield'}
                                               value={groupPattern}
                                               onInput={(event) => setGroupPattern(event.target.value)}
                                               label={'Поиск группы'}/>

                                    <Button size={'small'}
                                            onClick={() => {
                                                findGroup()
                                            }}
                                            startIcon={groupsListIsLoading ? <CircularProgress size={15}/> :
                                                <SearchIcon/>}>Поиск</Button>
                                </Stack>

                                <TextField size={'small'}
                                           select
                                           value={selectedGroup}
                                           onChange={(event) => {
                                               setSelectedGroup(event.target.value);
                                               setSelectedGroupId(event.target.value.groupId);
                                               getAvailableSemesters(event.target.value.groupId)
                                           }}
                                           label={'Выберите группу'}>
                                    {groups?.sort((l, r) => l.groupName > r.groupName ? 1 : -1).map((item) => {
                                        return <MenuItem key={item.groupName} value={item}>{item.groupName}</MenuItem>
                                    })}
                                </TextField>

                                <TextField size={'small'}
                                           select
                                           value={selectedSemester}
                                           onChange={(event) => {
                                               setSelectedSemester(event.target.value);
                                               setStudentsDetails(null);
                                               setGroupData(null);
                                           }}
                                           label={`Доступные семестры${semestersListIsLoading ? ' - загрузка...' : ''}`}>
                                    {semesters?.sort((l, r) => l.key > r.key ? -1 : 1).map((item) => {
                                        return <MenuItem key={item.value} value={item}>{item.value}</MenuItem>
                                    })}
                                </TextField>
                                
                                <Button variant={'contained'} 
                                        disabled={studentsDataIsLoading}
                                        onClick={() => loadData(parseInt(selectedSemester.key, 10))}
                                        startIcon={isLoading ? <CircularProgress size={15} /> : <SearchIcon />}
                                        size={'small'}>Просмотр</Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    {selectedGroup && groupData && !isLoading
                        ? <Stack spacing={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant={'h6'}>Карточка группы {selectedGroup?.groupName} {reportIsLoading ? '- загрузка отчёта займет некоторое время...' : ''} <IconButton size={'small'} disabled={reportIsLoading} onClick={() => {printReport()}}>{reportIsLoading ? <CircularProgress size={15} /> : <PrintIcon />}</IconButton></Typography>
                                    <br/>
                                    <Stack spacing={2}>
                                        <Typography><strong>Факультет: </strong>{groupData?.facultyName}</Typography>
                                        <Typography><strong>Курс: </strong>{groupData?.courseName}</Typography>
                                        <Typography><strong>Форма обучения: </strong>{groupData?.educationForm}
                                        </Typography>
                                    </Stack>
                                </CardContent>
                            </Card>

                            {!studentsDataIsLoading
                            ? <>
                                    <Card>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDownIcon/>}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <Typography variant={'h6'}>Дисциплины - {selectedSemester.value}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {studentsDetails?.sort((l,r) => l.fullName > r.fullName ? 1 : -1).map((studentData, index) => {
                                                    return <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ArrowDropDownIcon/>}
                                                            aria-controls="panel2-content"
                                                            id="panel2-header"
                                                        >
                                                            <Typography
                                                                component="span">{index + 1}. {studentData.fullName} {studentData.isFired ? '(отчислен)' : ''}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Stack>
                                                                <Table size={"small"}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Наименование</TableCell>
                                                                            <TableCell>Тип / Пропущено часов</TableCell>
                                                                            <TableCell>Аттестация 1</TableCell>
                                                                            <TableCell>Аттестация 2</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {studentData?.disciplinesResults?.map((disc) => {
                                                                            return <TableRow>
                                                                                <TableCell>
                                                                                    <strong>{disc.disciplineName}</strong>
                                                                                    <br/>
                                                                                    <small>Кафедра {disc.chairName}</small>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Table size={"small"} align={"left"}>
                                                                                        <TableBody>
                                                                                            {disc.lessonTypeDetails.length === 0
                                                                                                ? <TableRow>
                                                                                                    <TableCell>Лабораторная работа
                                                                                                        <br/>
                                                                                                        Не распределен(а) в подгруппу
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                : <></>}
                                                                                            {disc.lessonTypeDetails.map((ltd) => {
                                                                                                return <TableRow>
                                                                                                    <TableCell>{ltd.lessonType}
                                                                                                        <br/>
                                                                                                        <small>Пропущено {ltd.missedHours} / {ltd.totalHours}</small>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            })}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {disc.attestation1Grade !== null
                                                                                        ? `${disc.attestation1Grade}`
                                                                                        : ``}
                                                                                    <br/>
                                                                                    {disc.attestation1MissedHours !== null
                                                                                        ? <small>Пропущено часов: {disc.attestation1MissedHours}</small>
                                                                                        : <></>}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {disc.attestation2Grade !== null
                                                                                        ? `${disc.attestation2Grade}`
                                                                                        : ``}
                                                                                    <br/>
                                                                                    {disc.attestation2MissedHours !== null
                                                                                        ? <small>Пропущено часов: {disc.attestation2MissedHours}</small>
                                                                                        : <></>}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        })}
                                                                    </TableBody>
                                                                </Table>
                                                            </Stack>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Card>
                                    
                                    <Card>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDownIcon/>}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <Typography variant={'h6'}>Сессия - {selectedSemester.value}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {studentsDetails?.sort((l,r) => l.fullName > r.fullName ? 1 : -1).map((studentData, index) => {
                                                    return <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ArrowDropDownIcon/>}
                                                            aria-controls="panel2-content"
                                                            id="panel2-header"
                                                        >
                                                            <Typography
                                                                component="span">{index + 1}. {studentData.fullName} {studentData.isFired ? '(отчислен)' : ''}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Stack>
                                                                <Table size={"small"}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Дисциплина</TableCell>
                                                                            <TableCell>Тип контроля</TableCell>
                                                                            <TableCell>Преподаватели</TableCell>
                                                                            <TableCell>Ведомость</TableCell>
                                                                            <TableCell>Оценка</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {studentData?.sessionDetails?.sort((l, r) => l.disciplineName > r.disciplineName ? 1 : -1).map((disc, discIndex) => {
                                                                            return <>
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        rowSpan={disc?.detailsByControlType?.length ?? 1}>
                                                                                        <strong>{disc.disciplineName}</strong>
                                                                                    </TableCell>
                                                                                    {disc?.detailsByControlType.map((details, index) => {
                                                                                        if (index >= 1)
                                                                                            return null;

                                                                                        return getSessionDetailElements(details)
                                                                                    })}
                                                                                </TableRow>

                                                                                {disc?.detailsByControlType.map((details, index) => {
                                                                                    if (index < 1)
                                                                                        return null;

                                                                                    return <TableRow>
                                                                                        {getSessionDetailElements(details)}
                                                                                    </TableRow>
                                                                                })}
                                                                            </>
                                                                        })}
                                                                    </TableBody>
                                                                </Table>
                                                                <br/>
                                                                {studentData?.details?.averageSessionGradeBySemester !== null && studentData?.details?.averageSessionGradeBySemester !== undefined
                                                                    ? <Typography fontSize={'small'}><strong>Средняя
                                                                        оценка за
                                                                        семестр:</strong> {studentData.details.averageSessionGradeBySemester}
                                                                    </Typography>
                                                                    : <></>}

                                                                {studentData?.details?.averageSessionGradeByYear !== null && studentData?.details?.averageSessionGradeByYear !== undefined
                                                                    ? <Typography fontSize={'small'}><strong>Средняя
                                                                        оценка за
                                                                        год:</strong> {studentData.details.averageSessionGradeByYear}
                                                                    </Typography>
                                                                    : <></>}
                                                            </Stack>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Card>

                                    <Card>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDownIcon/>}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <Typography variant={'h6'}>Практика - {selectedSemester.value}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {studentsDetails?.map((studentData, index) => {
                                                    return <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ArrowDropDownIcon/>}
                                                            aria-controls="panel2-content"
                                                            id="panel2-header"
                                                        >
                                                            <Typography
                                                                component="span">{index + 1}. {studentData.fullName} {studentData.isFired ? '(отчислен)' : ''}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Stack>
                                                                <Table size={"small"}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Вид, тип практики</TableCell>
                                                                            <TableCell>Тип контроля</TableCell>
                                                                            <TableCell>Преподаватели</TableCell>
                                                                            <TableCell>Ведомость</TableCell>
                                                                            <TableCell>Оценка</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {studentData?.practiceDetails?.map((disc) => {
                                                                            return <TableRow>
                                                                                <TableCell>
                                                                                    <strong>
                                                                                        {disc.practiceType}<br/>
                                                                                        {disc.practiceKind === 1 ? 'Учебная' : 'Производственная'}
                                                                                    </strong>
                                                                                </TableCell>
                                                                                <TableCell>{disc.controlType === 1 ? 'Зачёт' : 'Зачёт с оценкой'}</TableCell>
                                                                                <TableCell>{disc.employees.join(', ')}</TableCell>
                                                                                <TableCell>
                                                                                    <Link
                                                                                        href={`/practice-statement-results/${disc.statementId}`}
                                                                                        target={"_blank"}>Ведомость
                                                                                        №{disc.statementNumber}</Link>
                                                                                    {disc.closingDate !== null
                                                                                        ? <>
                                                                                            <br/> Закрыта {toDateString(disc.closingDate)}</>
                                                                                        : <><br/> Открыта</>}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {disc.gradeName}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        })}
                                                                    </TableBody>
                                                                </Table>
                                                            </Stack>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Card>

                                    <Card>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDownIcon/>}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <Typography variant={'h6'}>Документы - {selectedSemester.value}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {studentsDetails?.filter((item) => item.documents && item.documents.length >= 1).map((studentData, index) => {
                                                    return <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ArrowDropDownIcon/>}
                                                            aria-controls="panel2-content"
                                                            id="panel2-header"
                                                        >
                                                            <Typography
                                                                component="span">{index + 1}. {studentData.fullName} {studentData.isFired ? '(отчислен)' : ''}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Table size={"small"}>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Наименование</TableCell>
                                                                        <TableCell>Файл</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {studentData?.documents?.map((doc) => {
                                                                        return <TableRow>
                                                                            <TableCell>{doc.documentName}</TableCell>
                                                                            <TableCell>
                                                                                {doc.fileGuid !== null && doc.fileGuid !== undefined
                                                                                    ? <Button href={`https://fs.kubsau.ru/File/${doc.fileGuid}`}
                                                                                              startIcon={<Download/>}
                                                                                              target={'_blank'}>Скачать</Button>
                                                                                    : <></>}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })}
                                                {studentsDetails?.filter((item) => item.documents && item.documents.length >= 1).length === 0
                                                ? <Typography>Список пуст</Typography>
                                                : <></>}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Card>

                                    <Typography fontSize={'small'}>* Для расчета средней оценки по сессии за семестр берутся оценки от 2 до 5 по закрытым ведомостям</Typography>
                                    <Typography fontSize={'small'}>** Для расчета средней оценки по сессиям за год берутся оценки от 2 до 5 по закрытым ведомостям, после чего группируются по типу сдачи. Если в первом семестре по предмету был зачёт, а во втором семестре экзамен, то для расчета будет браться экзаменационная оценка</Typography>
                                    <Typography fontSize={'small'}>*** Для расчета средней оценки за весь период обучения берутся оценки от 2 до 5 по сессиям, после чего группируются по типу сдачи. Если в первом семестре по предмету был зачёт, а во втором семестре экзамен, то для расчета будет браться экзаменационная оценка. Далее этот список оценок объединяется с оценками по практикам, после чего вычисляется средний балл по формуле - <em>"(ср. балл за все сессии + ср. балл за все практики) / 2"</em>. Если для студента не найдено ни одной оценки по практике, то считается средний балл лишь по сессиям</Typography>

                                </>
                                : <Stack spacing={2}>
                                    <Skeleton variant="rounded" height={60} sx={{ fontSize: '1rem' }} />
                                    <Skeleton variant="rounded" height={60} sx={{ fontSize: '1rem' }} />
                                    <Skeleton variant="rounded" height={60} sx={{ fontSize: '1rem' }} />
                                </Stack>}
                        </Stack>
                        : isLoading
                            ? <Stack alignItems={'center'}>
                                <CircularProgress/>
                            </Stack>
                            : <></>}
                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
